import React from "react";
import PropTypes from "prop-types";

// css
import * as styles from "./ProgramIncludes.module.css";

// images
import metabolicIcon from "../../../images/bookPack/metabolic-icn.png";
import aiIcon from "../../../images/bookPack/ai-icn.png";
import doctorIcon from "../../../images/bookPack/doctor-icn.png";

// Program features data
const PROGRAM_FEATURES = [
  {
    id: 1,
    imageSrc: metabolicIcon,
    imageAlt: "Metabolic healing icon",
    description:
      "Personalized metabolic healing through the Twin Health India app with real-time insights and guidance.",
  },
  {
    id: 2,
    imageSrc: aiIcon,
    imageAlt: "AI Digital Twin technology icon",
    description:
      "AI Digital Twin™ technology that learns your metabolism in real time to guide your healing.",
  },
  {
    id: 3,
    imageSrc: doctorIcon,
    imageAlt: "Expert doctors and health coaches icon",
    description:
      "Expert doctors and health coaches who guide your Twin Health India journey from start to finish.",
  },
];

// Feature Card Component
const FeatureCard = ({ imageSrc, imageAlt, description }) => (
  <div className="col-12 col-md-4">
    <div>
      <div className={styles.programInclude__img}>
        <img src={imageSrc} alt={imageAlt} loading="lazy" />
      </div>
      <div className={styles.programInclude__para}>
        <p>{description}</p>
      </div>
    </div>
  </div>
);

FeatureCard.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

const ProgramIncludes = () => {
  return (
    <section>
      <div className={`container ${styles.programInclude__container}`}>
        <div className="row">
          <div className="col-12">
            <div className={styles.programInclude__hdng}>
              <h3>Program Includes</h3>
            </div>
          </div>
        </div>
        <div className={`row ${styles.programInclude__bottomCard}`}>
          {PROGRAM_FEATURES.map(feature => (
            <FeatureCard
              key={feature.id}
              imageSrc={feature.imageSrc}
              imageAlt={feature.imageAlt}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramIncludes;
